<div class="card stat-card" [ngStyle]="{ 'background-color': data.bgColor }">
  <div class="card-content">
    <div class="card-title" [innerHTML]="formattedTitle"></div>
    <div class="card-value">{{ stat }}</div>
    <div class="input-container" *ngIf="data.key !== 'totalCost'">
      <input class="small-input" [formControl]="statControl" [placeholder]="'Enter ' + (data.key === 'simulatedPrice' ? 'Price' : 'Margin')" type="text">
      <span *ngIf="data.key === 'simulatedMargin'" class="unit-label">%</span>
      <button class="enter-btn" (click)="onEnterClick()">Enter</button>
    </div>
    <div *ngIf="data.key !== 'totalCost'" class="input-hint">💡 Enter value to auto-calculate the other</div>
  </div>
</div>
